import { ReactNode, useEffect, useMemo, useState } from 'react';
import LocalizationProvider from './LocalizationProvider';

type Props = {
  loadLocale: (locale: string, intlLocale?: string) => Promise<Record<string, string>>;
  locale: string;
  allowedLocales?: string[];
  children: ReactNode;
};
const OnDemandLocalizationProvider = ({ locale, loadLocale, allowedLocales, children }: Props) => {
  const [messages, setMessages] = useState<Record<string, string> | null>(null);
  const intlLocale = useMemo(
    () => allowedLocales?.find((l) => l.startsWith(locale.split('-')[0]!)) || locale,
    [locale, allowedLocales],
  );

  useEffect(() => {
    let mounted = true;
    loadLocale(locale, intlLocale).then((keys) => {
      if (mounted) {
        setMessages(keys);
      }
    });
    return () => {
      mounted = false;
    };
  }, [intlLocale, loadLocale, locale]);

  if (!messages) {
    return null;
  }

  return <LocalizationProvider {...{ locale: intlLocale, messages, children }} />;
};

export default OnDemandLocalizationProvider;
